import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import cn from 'classnames';

import * as css from './IconButton.css';
import { IconButtonVariants } from './IconButton.css';

type IconButtonProps = PropsWithChildren &
    ButtonHTMLAttributes<HTMLButtonElement> & {
        size?: IconButtonVariants['size'];
        variant?: IconButtonVariants['variant'];
    };

export function IconButton({ children, className, size, variant, ...props }: IconButtonProps) {
    return (
        <button className={cn(css.iconButton({ size, variant }), className)} {...props}>
            {children}
        </button>
    );
}
